<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">ShipZone fee prices</h4>
    </div>
    <form @submit.prevent="submitForm()">
      <v-alert type="success" :value="successAlert">
        ShipZone fee prices updated successfully
      </v-alert>
      <v-alert type="error" :value="errorAlert">
        Please update anything
      </v-alert>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 sm12 md7>
            <v-text-field
              style="width: 90%"
              label="ShipZone fee percentage*"
              :error-messages="errors.collect('ShipZone fee percentage')"
              v-validate="'required|decimal:4'"
              data-vv-name="ShipZone fee percentage"
              v-model.number="defaultPriceData.kreenex_fee_percentage"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md7>
            <v-text-field
              style="width: 90%"
              label="ShipZone fee base (USA)*"
              :error-messages="errors.collect('ShipZone fee base (USA)')"
              v-validate="'required|decimal:2'"
              data-vv-name="ShipZone fee base (USA)"
              v-model.number="defaultPriceData.kreenex_fee_base_usa"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md7>
            <v-text-field
              style="width: 90%"
              label="ShipZone fee (USA)*"
              :error-messages="errors.collect('ShipZone fee (USA)')"
              v-validate="'required|decimal:2'"
              data-vv-name="ShipZone fee (USA)"
              v-model.number="defaultPriceData.kreenex_fee_usa"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 sm12 md7>
            <v-text-field
              style="width: 90%"
              label="ShipZone fee base (Turkey)*"
              :error-messages="errors.collect('ShipZone fee base (Turkey)')"
              v-validate="'required|decimal:2'"
              data-vv-name="ShipZone fee base (Turkey)"
              v-model.number="defaultPriceData.kreenex_fee_base_turkey"
            ></v-text-field>
          </v-flex> -->
          <!-- <v-flex xs12 sm12 md7>
            <v-text-field
              style="width: 90%"
              label="ShipZone fee (Turkey)*"
              :error-messages="errors.collect('ShipZone fee (Turkey)')"
              v-validate="'required|decimal:2'"
              data-vv-name="ShipZone fee (Turkey)"
              v-model.number="defaultPriceData.kreenex_fee_turkey"
            ></v-text-field>
          </v-flex> -->
          <v-flex xs12 sm12 md7>
            <span style="color: red; font-size: 16px">* </span>
            <span style="font-size: 14px">
              In <b>Process Order</b> if <b>Item price</b> less than
              <i style="text-decoration: underline">ShipZone fee base (usa)</i>
              <br /><b>ShipZone fee</b> will be
              <i style="text-decoration: underline">ShipZone fee (usa)</i> , Otherwise
              <b>ShipZone fee</b> will be <br />
              <b> ShipZone fee (usa) + (item_price * ShipZone fee percentage)</b></span
            >
          </v-flex>
        </v-layout>
      </v-container>
      <v-spacer></v-spacer>
      <v-flex xs12 sm12 md7>
        <v-btn type="submit" style="width: 95%; height:auto; margin-bottom: 3%" color="success"
          >Save</v-btn
        >
      </v-flex>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  created() {
    let thePanel = document.querySelector('.panel-flat')
    thePanel.style.overflowX = 'hidden'
  },

  mounted() {
    this.getDefaultPrices()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      getDefaultPriceUrl: 'api/default_price',
      successAlert: false,
      errorAlert: false,
      defaultPriceData: {
        kreenex_fee_percentage: 0,
        kreenex_fee_base_usa: 0,
        kreenex_fee_base_turkey: 0,
        kreenex_fee_usa: 0,
        kreenex_fee_turkey: 0
      },
      updateDefaultPriceData: {
        kreenex_fee_percentage: 0,
        kreenex_fee_base_usa: 0,
        kreenex_fee_base_turkey: 0,
        kreenex_fee_usa: 0,
        kreenex_fee_turkey: 0
      }
    }
  },

  methods: {
    getDefaultPrices() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getDefaultPriceUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data.data

          this.defaultPriceData.kreenex_fee_percentage = result[0].kreenex_fee_percentage
          this.defaultPriceData.kreenex_fee_base_usa = result[0].kreenex_fee_base_usa
          this.defaultPriceData.kreenex_fee_base_turkey = result[0].kreenex_fee_base_turkey
          this.defaultPriceData.kreenex_fee_usa = result[0].kreenex_fee_usa
          this.defaultPriceData.kreenex_fee_turkey = result[0].kreenex_fee_turkey
        })
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.updateDefaultPriceData.kreenex_fee_percentage = this.defaultPriceData.kreenex_fee_percentage
          this.updateDefaultPriceData.kreenex_fee_base_usa = this.defaultPriceData.kreenex_fee_base_usa
          this.updateDefaultPriceData.kreenex_fee_base_turkey = this.defaultPriceData.kreenex_fee_base_turkey
          this.updateDefaultPriceData.kreenex_fee_usa = this.defaultPriceData.kreenex_fee_usa
          this.updateDefaultPriceData.kreenex_fee_turkey = this.defaultPriceData.kreenex_fee_turkey

          let token = localStorage.getItem('access_token')

          axios
            .put(this.getDefaultPriceUrl + '/' + 1 + '/kreenex_fee', this.updateDefaultPriceData, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.errorAlert = false
              this.successAlert = true

              let self = this
              setTimeout(() => {
                self.successAlert = false
              }, 2000)
            })
            .catch(() => {
              this.successAlert = false
              this.errorAlert = true

              let self = this
              setTimeout(() => {
                self.errorAlert = false
              }, 2000)
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.panel-heading {
  color: #006B8D;
  border-bottom: 2px solid #006B8D !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/kreenexFeePrices.vue